import {MutationTree} from "vuex";
import {
    MemberContactPerson,
    MembersState,
} from "@/store/member/types";
import OfflineDB from "@/store/member/offlinedb";
import _ from "lodash";

const mutations: MutationTree<MembersState> = {
    empty(state) {
        state.contacts = []
    },
    setContact(state, pl: MemberContactPerson) {
        OfflineDB.contacts.put({...pl}, pl.objvalueid)
        state.contacts = _.uniqBy(
            [pl, ...state.contacts],
            (e: MemberContactPerson) => `${e.objvalueid}`
        )
    },
}

export default mutations
